import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import closeIcon from '@/assets/icons/close-icn.svg';
import { ToastType, toastTypes } from '@/constants/toasts';

import classes from './Toast.module.scss';

interface ToastProps {
  id: number;
  message: string;
  type?: ToastType;
  icon?: string;
  duration?: number;
  onClose: (id: number) => void;
}

export const Toast = ({
  id,
  message,
  icon,
  duration = 3000,
  onClose,
  type = toastTypes.success,
}: ToastProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 10);

    const fadeOutTimer = setTimeout(() => {
      setIsFadingOut(true);
    }, duration - 300);

    const unmountTimer = setTimeout(() => {
      setIsMounted(false);
      onClose(id);
    }, duration);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(fadeOutTimer);
      clearTimeout(unmountTimer);
    };
  }, [duration, onClose, id]);

  const handleClose = () => {
    setIsFadingOut(true);
    setTimeout(() => onClose(id), 300); // время совпадает с временем анимации
  };

  const className = clsx(classes.toast, {
    [classes.visible]: isVisible && !isFadingOut,
    [classes.fadingOut]: isFadingOut,
    [classes.mounted]: isMounted,
    [classes[type]]: type,
  });

  return isMounted
    ? createPortal(
        <div className={className}>
          {icon && (
            <div className={classes.icon}>
              <img src={icon} alt="icon" />
            </div>
          )}
          <div className={classes.message}>{message}</div>
          <button className={classes.closeBtn} onClick={handleClose}>
            <img width={20} height={20} src={closeIcon} alt="close" />
          </button>
        </div>,
        document.body,
      )
    : null;
};
